function Icon({ children }) {
  return <div className="h-[24px] w-[24px]">{children}</div>
}

export function AvailableIntegration({ children }) {
  return (
    <div className="border border-cv-blue-200 bg-white px-5 py-4 flex gap-[15px] items-center">
      {children}
    </div>
  )
}

function Name({ children }) {
  return (
    <div className="text-sm font-bold text-cv-blue-400 flex gap-2 items-center font-roboto">
      {children}
    </div>
  )
}

AvailableIntegration.Icon = Icon
AvailableIntegration.Name = Name
